import React, {useRef, useState} from "react";
import PropTypes from "prop-types";
import {ATooltip} from "@cisco-sbg-ui/magna-react";
import Avatar from "./Avatar";

export default function AssigneeAvatar({
  email,
  name,
  useTooltip = true,
  tooltipPosition = "top",
  ...rest
}) {
  const avatarRef = useRef(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  // Split username string into an array of words
  const username = name ? name?.split(" ") : [];

  /**
   * @returns {string} First and last initial of name.
   * @remark If only first name exists, returns first 2 letters of first name.
   */
  const getNameInitials = () => {
    const firstName = username[0];
    const lastName = username[username.length - 1];

    return username?.length > 1
      ? `${firstName[0]}${lastName[0]}`
      : `${firstName[0]}${firstName[1]}`;
  };

  // If username doesn't exist, show user's email
  const value = name ? name : email;

  // Return username initials or first 2 letters of email
  const initials =
    username?.length > 0 ? getNameInitials() : value?.substring(0, 2);

  return (
    <>
      <Avatar
        aria-describedby={value}
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}
        ref={avatarRef}
        {...rest}>
        {initials.toUpperCase()}
      </Avatar>
      <ATooltip
        anchorRef={avatarRef}
        open={isTooltipOpen && useTooltip}
        placement={tooltipPosition}
        style={{maxWidth: "100%", minWidth: 0, whiteSpace: "nowrap"}}>
        {value}
      </ATooltip>
    </>
  );
}

AssigneeAvatar.propTypes = {
  /**
   * User or assignee's email
   */
  email: PropTypes.string,
  /**
   * User or assignee's username
   */
  name: PropTypes.string,
  /**
   * If false, tooltip will not be shown when hovering over avatar
   *
   * @defaultValue true
   */
  useTooltip: PropTypes.bool,
  /**
   * Sets the placement of avatar tooltips
   *
   * @defaultValue top
   */
  tooltipPosition: PropTypes.string
};
